export const buyXGetYValues = {
  allTogether: 'all_together',
  separately: 'individual',
}

export const buyXGetYOptions = [
  {
    label: 'Juntos como un único elemento',
    value: buyXGetYValues.allTogether,
  },
  {
    label: 'De forma individual',
    value: buyXGetYValues.separately,
  },
]
